(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/javascripts/game-package-mappers.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/javascripts/game-package-mappers.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  gameWager,
  productMapping
} = svs.numbergames;
function generateGames(_ref) {
  let {
    packageSizes,
    activeIndex
  } = _ref;
  const {
    games = []
  } = packageSizes[activeIndex] || {};
  return games.map((game, index) => {
    var _wager$joker;
    const wager = gameWager.generateWager(game);
    const productItsId = wager.products[0];
    return _objectSpread(_objectSpread({}, wager), {}, {
      hasJoker: Boolean((_wager$joker = wager.joker) === null || _wager$joker === void 0 ? void 0 : _wager$joker.price),
      price: gameWager.calculateWagerPrice(wager),
      productItsId,
      uniqueId: "".concat(productItsId, "_").concat(index)
    });
  });
}
function gamesSortOrder(_ref2) {
  let {
    games,
    draws
  } = _ref2;
  const sortOrder = games.map(w => ({
    productItsId: w.productItsId,
    uniqueId: w.uniqueId
  }));
  const findDrawIndex = productItsId => draws.findIndex(d => d.productItsId === productItsId);
  sortOrder.sort((a, b) => findDrawIndex(a.productItsId) - findDrawIndex(b.productItsId));
  return sortOrder;
}
function getJackpots(_ref3) {
  let {
    games,
    jackpots,
    weekDraws
  } = _ref3;
  const jackpotsList = games.map(game => {
    let kenoBoards;
    if (productMapping.isKeno(game.productItsId)) {
      kenoBoards = game.boards.map(board => ({
        kenoLevel: board.level,
        hasKungKeno: board.hasKungKeno,
        rowPrice: board.rowPrice * board.rowPriceMulti
      }));
    }
    const {
      jackpotAmount,
      description,
      jackpotAmountStringShort
    } = svs.numbergames.jackpot.getJackpot({
      product: game.productItsId,
      jackpots,
      draws: weekDraws,
      kenoBoards
    });
    return {
      productItsId: game.productItsId,
      jackpotAmount,
      jackpotText: "".concat(description, " ").concat(jackpotAmountStringShort)
    };
  });
  games.map(game => {
    if (!game.hasJoker) {
      return null;
    }
    const {
      jackpotAmount
    } = svs.numbergames.jackpot.getJackpot({
      product: productMapping.getJokerProductId(game.productItsId),
      jokerPrice: game.joker.price
    });
    return jackpotsList.push({
      productItsId: productMapping.getJokerProductId(game.productItsId),
      jackpotAmount
    });
  });
  return jackpotsList;
}
svs.gamePackage.mappers = {
  generateGames,
  gamesSortOrder,
  getJackpots
};

 })(window);